/**
 * Tâche 1424 (Eric 2026-10-01) — Le droit de créer un sondage.
 *
 * Un seul appel, partagé par le panneau Canaux et par les conversations : le
 * bouton « Sondage » doit apparaître aux deux endroits selon la même règle,
 * et deux lectures séparées finiraient par diverger au premier changement.
 *
 * En cas d'échec de l'appel, on répond NON : afficher le bouton puis se faire
 * refuser à l'envoi serait pire qu'un bouton absent.
 */
import { useEffect, useState } from "react";
import axios from "axios";

import { API_BASE as API } from "../lib/apiBase";

export function usePollPermission() {
  const [canCreatePoll, setCanCreatePoll] = useState(false);

  useEffect(() => {
    let vivant = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/polls/can-create`, { withCredentials: true });
        if (vivant) setCanCreatePoll(!!data.can_create);
      } catch {
        if (vivant) setCanCreatePoll(false);
      }
    })();
    return () => { vivant = false; };
  }, []);

  return { canCreatePoll };
}
